export function getScrollbarWidth() {
  const documentWidth = document.documentElement.clientWidth
  const windowWidth = window.innerWidth
  return windowWidth - documentWidth
}
